export default [
  {
    path: "/report/invoiceinfo",
    name: "InvoiceInfo-View",
    component: () => import("@/views/commission/invoice/invoice-info.vue"),
    meta: {
      resource: "Report",
      action: "Invoice",
    },
  },
  {
    path: "/report/invoiceinfo-create",
    name: "InvoiceInfo-Create",
    component: () =>
      import("@/views/commission/invoice/invoice-info-create.vue"),
    meta: {
      resource: "Report",
      action: "Invoice",
    },
  },
  {
    path: "/report/invoiceinfo-edit/:id",
    name: "InvoiceInfo-Edit",
    component: () => import("@/views/commission/invoice/invoice-info-edit.vue"),
    meta: {
      resource: "Report",
      action: "Invoice",
    },
  },
  {
    path: "/report/invoiceinfo/:id",
    name: "InvoiceInfo-Details",
    component: () =>
      import("@/views/commission/invoice/invoice-info-details.vue"),
    meta: {
      resource: "Report",
      action: "Invoice",
    },
  },
  {
    path: "/commissionFee/index",
    name: "CommissionFee-list",
    component: () => import("@/views/commission/index.vue"),
    meta: {
      resource: "CommissionFee",
      action: "GetAll",
    },
  },
  // {
  //   path: "/commissionFee/details",
  //   name: "CommissionFee-Details",
  //   component: () => import("@/views/commission/details.vue"),
  //   meta: {
  //     resource: "CommissionFee",
  //     action: "GetAll",
  //   },
  // },
  {
    path: "/commissionFee/create",
    name: "CommissionFee-create",
    component: () => import("@/views/commission/add.vue"),
    meta: {
      resource: "CommissionFee",
      action: "Create",
    },
  },
  {
    path: "/commissionFee/update/:id",
    name: "CommissionFee-update",
    component: () => import("@/views/commission/Edit.vue"),
    meta: {
      resource: "CommissionFee",
      action: "Update",
    },
  },
  {
    path: "/commissionFee/merchantCommissions",
    name: "CommissionFee-merchantCommissions",
    component: () => import("@/views/commission/merchantCommissions.vue"),
    meta: {
      resource: "Merchants",
      action: "GetMerchantCommissionFee",
    },
  },
  {
    path: "/report/invoice",
    name: "Invoice-View",
    component: () => import("@/views/commission/invoice/invoice.vue"),
    meta: {
      resource: "Report",
      action: "Invoice",
    },
  },

  // {
  //   path: "/report/invoice_to_PDF",
  //   name: "Invoice_PDF-View",
  //   component: () => import("@/views/commission/invoice/invoice_to_PDF.vue"),
  //   props: true,
  //   meta: {
  //     resource: "Report",
  //     action: "Invoice",
  //   },
  // },
];
